import { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import dayjs from "dayjs"
import {
  useEffect,
  useState,
} from "react"
import { useDaySelector } from "../useDaySelector"
import { useFollowedUsers } from "src/contexts"
import { useEventsAndSubEntriesOfType } from "src/hooks"

export function useExerciseDayMetric(dayStart: string): number {
  const daySelector = useDaySelector(dayStart)
  const { currentFollow } = useFollowedUsers()

  const {
    isFetchingEvents,
    isFetchingEntries,
    events: exerciseEvents,
    subEntries: exerciseSubEntries,
  } = useEventsAndSubEntriesOfType(
    currentFollow.following_account_id,
    ActivityType.Exercise,
    daySelector,
  )

  const [
    exerciseTotal,
    setExerciseTotal,
  ] = useState<number>(NaN)

  useEffect(
    () => {
      if (isFetchingEvents || isFetchingEntries) {
        return
      }

      let totalInMinutes = 0

      exerciseEvents.forEach(
        (exerciseEvent) => {
          const durationInMinutes = dayjs(exerciseEvent.ended_at).diff(
            exerciseEvent.started_at,
            "minute",
            true,
          )
          totalInMinutes += durationInMinutes
        },
      )

      exerciseSubEntries.forEach(
        (subEntry) => {
          if (subEntry.duration_in_seconds) {
            totalInMinutes += subEntry.duration_in_seconds / 60
          }
        },
      )

      setExerciseTotal(totalInMinutes)
    },
    [
      isFetchingEvents,
      isFetchingEntries,
      setExerciseTotal,
      exerciseEvents,
      exerciseSubEntries,
    ],
  )

  return exerciseTotal
}
